import { Button } from "@/components/ui";

export default function FallbackErrorPage({ eventId }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg p-6">
      <div className="max-w-md w-full rounded-lg border border-border bg-surface shadow-panel p-8 text-center">
        <div className="text-5xl mb-4" aria-hidden="true">⚠️</div>
        <h1 className="text-xl font-semibold text-text mb-2">Algo salió mal</h1>
        <p className="text-text-muted mb-6">
          La aplicación encontró un error inesperado. Intentá recargar la página.
        </p>
        <Button onClick={() => window.location.reload()}>Recargar</Button>
        {eventId && (
          <p className="text-xs text-text-muted mt-6">
            ID de error: <span className="font-mono">{eventId}</span>
          </p>
        )}
      </div>
    </div>
  );
}
